import * as R from 'ramda';

const removePlacement = store => async (
    state,
    { rhId, placement },
    deleted = true,
) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);

    const placements = deleted
        ? (rightsholders[rhIndex].placements || []).filter(
              p => p.id !== placement.id,
          )
        : (rightsholders[rhIndex].placements || []).map(p =>
              p.id === placement.id
                  ? { ...p, active: false, clientRemoved: true }
                  : p,
          );

    const placementLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
    ]);

    store.setState(R.set(placementLens, placements, store.getState()), true);
};

export default removePlacement;
